import { PublicSectionGate } from '@components/PublicPage'
import { usePublicItinerary } from '@hooks'
import TripMapView from '@pages/TripMap/TripMapView'
import React from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import PublicSectionLayout from '../PublicSections/PublicSectionLayout'
import { publicItineraryPath } from './paths'
import { MapCard } from './PublicTripMapPage.styles'

/**
 * Public, read-only full map at `/shared/trips/:tripCode/itinerary/map`: the
 * member map view in public mode, fed by the public itinerary (so it shares its
 * cache and its section share setting), inside the public section chrome.
 */
const PublicTripMapPage: React.FC = () => {
	const { tripCode = '' } = useParams<{ tripCode: string }>()
	const navigate = useNavigate()
	const [searchParams] = useSearchParams()
	const query = usePublicItinerary(tripCode)
	const itinerary = publicItineraryPath(tripCode)

	return (
		<PublicSectionGate
			query={query}
			loadingLabel="Loading map…"
			unavailableTitle="Itinerary Unavailable"
			unavailableMessage="This itinerary doesn't exist or has been set to private by the trip owner."
		>
			{({ trip, events }) => (
				<PublicSectionLayout tripCode={tripCode} title="Trip Map" backTo={{ path: itinerary, label: 'Itinerary' }} fill>
					<MapCard>
						<TripMapView
							trip={trip}
							events={events}
							dayParam={searchParams.get('day')}
							emptyDescription="This trip's events don't have locations yet."
							onBackToItinerary={() => navigate(itinerary)}
						/>
					</MapCard>
				</PublicSectionLayout>
			)}
		</PublicSectionGate>
	)
}

export default PublicTripMapPage
